// extracted by mini-css-extract-plugin
module.exports = {"container":"FullDealEntryPointBanner_container__3fhqK","title":"FullDealEntryPointBanner_title__30hgw","image":"FullDealEntryPointBanner_image__21ZFK"};